import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function NoDataIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "615",
    height: "300",
    viewBox: "0 0 615 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsxs("g", {
      opacity: "0.7",
      clipPath: "url(#clip0_1553_29083)",
      children: [/*#__PURE__*/_jsx("path", {
        opacity: "0.14",
        d: "M378.5 419C492.547 419 585 326.547 585 212.5C585 98.4532 492.547 6 378.5 6C264.453 6 172 98.4532 172 212.5C172 326.547 264.453 419 378.5 419Z",
        fill: "url(#paint0_radial_1553_29083)"
      }), /*#__PURE__*/_jsx("path", {
        opacity: "0.4",
        d: "M283.5 384C384.292 384 466 302.292 466 201.5C466 100.708 384.292 19 283.5 19C182.708 19 101 100.708 101 201.5C101 302.292 182.708 384 283.5 384Z",
        fill: "url(#paint1_radial_1553_29083)"
      })]
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_dd_1553_29083)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M458.52 223.341L336.785 190.425C333.112 189.05 327.917 190.1 325.766 192.239L205.733 312.016C205.275 312.473 204.642 312.698 204.342 313.35C203.378 315.44 206.988 321.163 209.562 321.853L334.618 355.361C337.557 356.149 341.684 355.054 343.835 352.915L462.615 234.263C465.801 230.167 461.459 224.129 458.52 223.341Z",
        fill: "url(#paint2_linear_1553_29083)"
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M457.169 222.658L334.256 189.724C331.056 188.866 326.561 190.071 324.218 192.414L205.924 310.708C203.581 313.051 204.276 315.646 207.477 316.504L328.457 348.92C332.725 350.064 338.717 348.458 341.842 345.334L458.722 228.454C461.065 226.111 460.37 223.516 457.169 222.658Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#filter1_f_1553_29083)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M342.731 347.675L459.199 229.104C461.384 226.879 460.853 224.422 457.98 223.465L450.784 221.066L335.15 190.603C331.953 189.761 327.486 190.962 325.148 193.292L206.528 311.527C204.197 313.85 204.852 316.428 207.996 317.31L329.186 351.292C333.483 352.497 339.599 350.863 342.731 347.675Z",
        fill: "url(#paint3_linear_1553_29083)"
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M457.169 222.658L334.256 189.724C331.056 188.866 326.561 190.071 324.218 192.414L205.924 310.708C203.581 313.051 204.276 315.646 207.477 316.504L328.457 348.92C332.725 350.064 338.717 348.458 341.842 345.334L458.722 228.454C461.065 226.111 460.37 223.516 457.169 222.658Z",
      fill: "url(#paint4_linear_1553_29083)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M338.997 221.561C338.864 221.098 338.047 220.979 337.387 220.81L284.098 207.105C283.519 206.95 282.731 207.108 282.07 207.468C281.51 207.774 281.09 208.172 280.575 208.509L279.549 209.181C279.034 209.519 278.547 209.894 278.415 210.309C278.164 211.092 278.382 212.101 279.007 212.269L333.201 226.79C334.016 227.008 335.245 226.607 335.948 225.894L338.493 223.312C338.941 222.858 339.143 222.072 338.997 221.561Z",
      fill: "#4926CD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M338.292 220.716L284.098 206.195C283.284 205.977 282.055 206.378 281.351 207.091L278.806 209.673C278.103 210.386 278.193 211.141 279.007 211.359L333.202 225.88C334.016 226.098 335.245 225.697 335.948 224.984L338.493 222.402C339.197 221.689 339.106 220.934 338.292 220.716Z",
      fill: "#6942F8"
    }), /*#__PURE__*/_jsx("path", {
      d: "M345.635 238.659C345.325 238.392 344.726 238.332 344.229 238.203L271.876 219.395C271.192 219.212 270.368 219.274 269.675 219.52C268.843 219.815 268.247 220.368 267.522 220.785L266.892 221.146C266.166 221.563 265.502 222.066 265.496 222.598C265.487 223.392 266.023 224.354 266.805 224.564L339.943 244.161C341.043 244.456 342.5 244.116 343.2 243.402L345.736 240.818C346.276 240.266 346.222 239.164 345.635 238.659Z",
      fill: "#4926CD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M344.763 238.015L271.625 218.418C270.526 218.123 269.068 218.463 268.368 219.177L265.833 221.762C265.133 222.476 265.456 223.292 266.555 223.587L339.693 243.184C340.792 243.479 342.249 243.139 342.95 242.425L345.485 239.84C346.185 239.126 345.862 238.31 344.763 238.015Z",
      fill: "#6942F8"
    }), /*#__PURE__*/_jsx("path", {
      d: "M299.054 259.675C298.943 259.194 298.11 259.066 297.433 258.892L245.564 245.567C244.995 245.415 244.209 245.581 243.551 245.95C243.011 246.254 242.602 246.641 242.103 246.971L241.048 247.669C240.548 247.999 240.075 248.365 239.936 248.77C239.668 249.552 239.86 250.566 240.472 250.73L293.262 264.875C294.055 265.088 295.267 264.683 295.971 263.969L298.517 261.388C298.955 260.943 299.17 260.183 299.054 259.675Z",
      fill: "#4926CD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M298.373 258.807L245.583 244.662C244.79 244.45 243.578 244.855 242.874 245.568L240.328 248.15C239.625 248.863 239.698 249.613 240.491 249.825L293.281 263.97C294.074 264.183 295.286 263.777 295.99 263.064L298.536 260.483C299.239 259.769 299.166 259.02 298.373 258.807Z",
      fill: "#6942F8"
    }), /*#__PURE__*/_jsx("path", {
      d: "M298.315 241.908C298.119 241.622 297.649 241.487 297.185 241.374L257.772 231.772C257.302 231.647 256.549 231.898 255.905 232.359C255.542 232.618 255.236 232.905 254.876 233.167L253.567 234.119C253.207 234.38 252.865 234.658 252.692 234.964C252.258 235.736 252.177 236.801 252.666 236.932L292.325 247.559C292.921 247.718 294.447 247.262 295.153 246.55L297.883 243.819C298.44 243.257 298.685 242.448 298.315 241.908Z",
      fill: "#4926CD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M297.623 241.54L257.963 230.914C257.368 230.754 256.314 231.202 255.608 231.915L253.055 234.494C252.35 235.207 252.262 235.914 252.857 236.073L292.517 246.7C293.113 246.86 294.167 246.412 294.872 245.699L297.425 243.119C298.13 242.407 298.219 241.7 297.623 241.54Z",
      fill: "#6942F8"
    }), /*#__PURE__*/_jsx("path", {
      d: "M306.438 279.61C306.128 279.344 305.529 279.283 305.031 279.154L232.678 260.346C231.994 260.163 231.171 260.226 230.478 260.471C229.646 260.766 229.05 261.319 228.324 261.736L227.695 262.098C226.969 262.515 226.305 263.018 226.299 263.549C226.29 264.344 226.826 265.306 227.608 265.516L300.746 285.113C301.845 285.407 303.303 285.068 304.003 284.354L306.538 281.769C307.079 281.218 307.025 280.115 306.438 279.61Z",
      fill: "#4926CD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M305.565 278.966L232.427 259.369C231.328 259.075 229.87 259.414 229.17 260.128L226.635 262.713C225.934 263.427 226.258 264.244 227.356 264.538L300.495 284.135C301.594 284.43 303.051 284.09 303.751 283.376L306.287 280.792C306.987 280.078 306.664 279.261 305.565 278.966Z",
      fill: "#6942F8"
    }), /*#__PURE__*/_jsx("path", {
      d: "M259.12 282.86C258.924 282.573 258.454 282.438 257.99 282.325L218.577 272.724C218.107 272.598 217.353 272.849 216.71 273.31C216.347 273.57 216.04 273.856 215.681 274.118L214.371 275.07C214.012 275.332 213.67 275.609 213.497 275.916C213.063 276.687 212.982 277.752 213.47 277.883L253.13 288.51C253.726 288.67 255.252 288.214 255.957 287.501L258.688 284.771C259.245 284.208 259.489 283.399 259.12 282.86Z",
      fill: "#4926CD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M258.427 282.492L218.768 271.865C218.172 271.706 217.118 272.153 216.413 272.866L213.86 275.446C213.155 276.158 213.066 276.865 213.662 277.025L253.321 287.651C253.917 287.811 254.971 287.363 255.677 286.651L258.23 284.071C258.935 283.358 259.023 282.652 258.427 282.492Z",
      fill: "#6942F8"
    }), /*#__PURE__*/_jsx("path", {
      d: "M329.881 214.078L328.245 213.639L328.356 207.544L323.579 212.389L321.97 211.958L328.724 205.107L330.36 205.546L330.249 211.641L335.026 206.796L336.635 207.227L329.881 214.078ZM334.948 215.586C334.253 215.4 333.737 215.115 333.397 214.731C333.066 214.35 332.938 213.914 333.011 213.423C333.094 212.935 333.38 212.442 333.869 211.946C334.359 211.449 334.96 211.041 335.674 210.722C336.396 210.405 337.151 210.206 337.939 210.124C338.735 210.045 339.48 210.098 340.175 210.284C340.86 210.467 341.368 210.75 341.698 211.131C342.038 211.515 342.171 211.953 342.097 212.443C342.024 212.934 341.742 213.428 341.253 213.924C340.763 214.421 340.157 214.827 339.435 215.144C338.712 215.461 337.953 215.659 337.156 215.738C336.369 215.82 335.633 215.77 334.948 215.586ZM335.424 212.362C335.137 212.654 334.963 212.946 334.902 213.239C334.856 213.528 334.927 213.786 335.115 214.012C335.311 214.24 335.608 214.407 336.005 214.514C336.401 214.62 336.831 214.647 337.292 214.595C337.754 214.543 338.192 214.422 338.607 214.232C339.038 214.038 339.397 213.795 339.684 213.504C339.971 213.213 340.138 212.922 340.183 212.633C340.244 212.34 340.181 212.081 339.994 211.855C339.806 211.629 339.514 211.463 339.117 211.356C338.721 211.25 338.287 211.222 337.816 211.271C337.355 211.323 336.909 211.446 336.478 211.641C336.063 211.831 335.712 212.071 335.424 212.362ZM350.259 219.538L348.744 219.132L349.459 218.407C348.903 218.601 348.345 218.716 347.787 218.75C347.229 218.785 346.702 218.735 346.206 218.603C345.566 218.431 345.099 218.159 344.804 217.788C344.519 217.418 344.426 216.992 344.527 216.508C344.636 216.027 344.936 215.539 345.425 215.042C345.915 214.546 346.503 214.134 347.189 213.808C347.885 213.484 348.604 213.275 349.346 213.181C350.097 213.089 350.793 213.129 351.433 213.301C351.929 213.433 352.312 213.628 352.583 213.885C352.855 214.142 353.001 214.444 353.022 214.793L355.792 211.983L357.306 212.389L350.259 219.538ZM346.98 215.459C346.693 215.75 346.519 216.042 346.458 216.336C346.412 216.625 346.483 216.882 346.671 217.108C346.858 217.334 347.155 217.501 347.561 217.61C347.957 217.716 348.386 217.743 348.848 217.691C349.31 217.639 349.748 217.518 350.163 217.328C350.594 217.134 350.953 216.891 351.24 216.6C351.527 216.309 351.694 216.019 351.739 215.73C351.8 215.437 351.737 215.177 351.55 214.951C351.362 214.725 351.07 214.559 350.673 214.453C350.268 214.344 349.834 214.316 349.372 214.368C348.911 214.42 348.465 214.543 348.034 214.737C347.619 214.927 347.267 215.168 346.98 215.459ZM359.001 221.88L357.486 221.475L358.201 220.75C357.645 220.944 357.088 221.058 356.53 221.093C355.971 221.127 355.444 221.078 354.948 220.945C354.308 220.774 353.841 220.502 353.546 220.13C353.261 219.761 353.169 219.334 353.269 218.851C353.379 218.37 353.678 217.881 354.168 217.385C354.657 216.888 355.245 216.477 355.931 216.15C356.627 215.826 357.346 215.617 358.088 215.523C358.84 215.432 359.535 215.472 360.175 215.643C360.671 215.776 361.055 215.971 361.326 216.228C361.597 216.484 361.743 216.787 361.764 217.136L362.478 216.411L363.993 216.817L359.001 221.88ZM355.723 217.801C355.436 218.093 355.261 218.385 355.2 218.678C355.155 218.967 355.226 219.225 355.413 219.451C355.601 219.676 355.897 219.844 356.303 219.953C356.7 220.059 357.129 220.086 357.59 220.034C358.052 219.982 358.49 219.861 358.906 219.671C359.336 219.477 359.695 219.234 359.982 218.943C360.27 218.651 360.436 218.361 360.482 218.072C360.543 217.779 360.479 217.519 360.292 217.294C360.104 217.068 359.812 216.901 359.416 216.795C359.01 216.686 358.576 216.658 358.115 216.71C357.653 216.762 357.207 216.885 356.776 217.079C356.361 217.269 356.01 217.51 355.723 217.801ZM364.645 221.297C364.417 221.528 364.329 221.727 364.383 221.892C364.437 222.057 364.626 222.183 364.951 222.27C365.257 222.352 365.632 222.377 366.074 222.345L365.046 223.387C364.53 223.425 364.042 223.382 363.583 223.259C362.852 223.063 362.439 222.777 362.344 222.4C362.255 222.016 362.458 221.573 362.954 221.069L365.489 218.498L364.326 218.186L365.325 217.174L366.488 217.485L367.78 216.175L369.294 216.58L368.002 217.891L369.95 218.413L368.951 219.425L367.004 218.904L364.645 221.297ZM373.039 225.642L371.524 225.236L372.239 224.511C371.683 224.705 371.126 224.82 370.568 224.854C370.009 224.889 369.482 224.839 368.986 224.707C368.346 224.535 367.879 224.263 367.584 223.892C367.299 223.522 367.207 223.096 367.307 222.612C367.417 222.131 367.716 221.643 368.206 221.146C368.695 220.65 369.283 220.238 369.969 219.912C370.665 219.588 371.384 219.379 372.126 219.285C372.878 219.193 373.573 219.233 374.213 219.405C374.709 219.537 375.093 219.732 375.364 219.989C375.635 220.246 375.781 220.548 375.802 220.897L376.516 220.172L378.031 220.578L373.039 225.642ZM369.761 221.563C369.474 221.854 369.299 222.146 369.238 222.439C369.193 222.729 369.264 222.986 369.451 223.212C369.639 223.438 369.935 223.605 370.341 223.714C370.738 223.82 371.167 223.847 371.628 223.795C372.09 223.743 372.528 223.622 372.944 223.432C373.374 223.238 373.733 222.995 374.02 222.704C374.308 222.413 374.474 222.123 374.52 221.834C374.581 221.541 374.517 221.281 374.33 221.055C374.142 220.829 373.85 220.663 373.454 220.557C373.048 220.448 372.614 220.42 372.153 220.472C371.691 220.524 371.245 220.647 370.814 220.841C370.399 221.031 370.048 221.272 369.761 221.563Z",
      fill: "#282863"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_dd_1553_29083",
        x: "184.182",
        y: "159.806",
        width: "299.551",
        height: "223.811",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "-10"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1553_29083"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "8"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1553_29083",
          result: "effect2_dropShadow_1553_29083"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect2_dropShadow_1553_29083",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_f_1553_29083",
        x: "204.132",
        y: "189.334",
        width: "257.411",
        height: "163.354",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "0.5",
          result: "effect1_foregroundBlur_1553_29083"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        id: "paint0_radial_1553_29083",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(378.5 212.5) scale(206.5)",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FF8FE6"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#FF8FE6",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        id: "paint1_radial_1553_29083",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(283.5 201.5) scale(182.5)",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#8296FF",
          stopOpacity: "0.6"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#8296FF",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear_1553_29083",
        x1: "465.33",
        y1: "219.832",
        x2: "191.251",
        y2: "152.605",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#8B98DE"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.200284",
          stopColor: "#C1CBFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.303741",
          stopColor: "#E9ECFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.310958",
          stopColor: "#DDE2FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.333069",
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.491969",
          stopColor: "#CED6FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.857402",
          stopColor: "#94A0E3"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#DAE0FF"
        })]
      }), /*#__PURE__*/_jsx("linearGradient", {
        id: "paint3_linear_1553_29083",
        x1: "463.981",
        y1: "213.33",
        x2: "-53.2373",
        y2: "882.82",
        gradientUnits: "userSpaceOnUse",
        children: /*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        })
      }), /*#__PURE__*/_jsx("linearGradient", {
        id: "paint4_linear_1553_29083",
        x1: "463.07",
        y1: "212.42",
        x2: "-54.1486",
        y2: "881.91",
        gradientUnits: "userSpaceOnUse",
        children: /*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_1553_29083",
        children: /*#__PURE__*/_jsx("rect", {
          width: "615",
          height: "418",
          fill: "white"
        })
      })]
    })]
  });
}